import { registerCondition } from 'core/forms';

import isTimingValidBasedOnTrigger from '../validators/isTimingValidBasedOnTrigger';

const isTimingNotOffset = ({ model }) => {
  const { timing } = model;
  const isTimingInvalid = isTimingValidBasedOnTrigger({ fieldValue: timing, model }).hasError;

  return {
    condition: null,
    hasCondition: !timing || isTimingInvalid,
  };
};

registerCondition('isTimingNotOffset', isTimingNotOffset);

export default isTimingNotOffset;
